import React from 'react';
import {t} from '@lingui/core/macro';

import AdminCreateButton from '../AdminList/AdminCreateButton';
import TariffModal from './TariffModal';

const CreateTariffButton: React.FC = () => (
    <AdminCreateButton label={t`Добавить тариф`} Modal={TariffModal}/>
);

export default CreateTariffButton;
